import { t } from 'localization'
import Image from 'shared/components/Image'
import { HomepageQA } from 'shared/dataAttributes'
import { useWindowSize } from 'shared/hooks/useWindowSize'
import styled, { css } from 'styled-components'

export type Picture = {
  thumbUrl: string
  smallUrl: string
  mediumUrl: string
  largeUrl: string
}

type ImageHeroProps = {
  pictures: Picture[]
  title?: string
}

const TP = 'homepage.ImageHero'

const ImageHero = ({ pictures, title }: ImageHeroProps) => {
  const { isLoading, isMobile } = useWindowSize()

  return (
    <>
      {pictures?.length === 1 && (
        <ImageWrapper $isLoadingWindow={isLoading}>
          <StyledImage
            data-testid="heroImage"
            src={pictures[0].largeUrl}
            alt={t(`${TP}.heroImageAlt`, {
              defaultValue: '{title} Hero Picture',
              title,
            })}
          />
        </ImageWrapper>
      )}
      {pictures?.length > 1 && (
        <>
          {isMobile ? (
            <MobileImageWrapper $isLoadingWindow={isLoading}>
              <MobileStyledImage
                data-qa={HomepageQA.HeroImageMobile}
                data-testid="heroImageMobile"
                src={pictures[1].largeUrl}
                alt={t(`${TP}.heroImageMobileAlt`, {
                  defaultValue: '{title} Hero Picture Mobile',
                  title,
                })}
                sizes="100vw"
                fill
                priority={true}
              />
            </MobileImageWrapper>
          ) : (
            <DesktopImageWrapper $isLoadingWindow={isLoading}>
              <DesktopStyledImage
                data-qa={HomepageQA.HeroImageDesktop}
                data-testid="heroImageDesktop"
                src={pictures[0].largeUrl}
                alt={t(`${TP}.heroImageDesktopAlt`, {
                  defaultValue: '{title} Hero Picture Desktop',
                  title,
                })}
                sizes="100vw"
                fill
                priority={true}
              />
            </DesktopImageWrapper>
          )}
        </>
      )}
    </>
  )
}

const ImageWrapper = styled.div<{ $isLoadingWindow: boolean }>`
  position: absolute;
  inset: 0;

  ${({ $isLoadingWindow }) =>
    $isLoadingWindow &&
    css`
      display: none;
    `};
`
// the &&& trick to is to assure extended styles override
// their base component styles
// https://github.com/styled-components/styled-components/issues/382
const StyledImage = styled(Image)`
  &&& {
    height: 100%;
    object-fit: cover;
  }
`
const DesktopImageWrapper = styled.div<{ $isLoadingWindow: boolean }>`
  display: block;
  position: absolute;
  inset: 0;

  ${({ $isLoadingWindow }) =>
    $isLoadingWindow &&
    css`
      display: none;
    `};
`
// the &&& trick to is to assure extended styles override
// their base component styles
// https://github.com/styled-components/styled-components/issues/382
const DesktopStyledImage = styled(Image)`
  display: block;

  &&& {
    height: 100%;
    object-fit: cover;
  }
`
const MobileImageWrapper = styled.div<{ $isLoadingWindow: boolean }>`
  position: absolute;
  inset: 0;

  ${({ $isLoadingWindow }) =>
    $isLoadingWindow &&
    css`
      display: none;
    `};
`
// the &&& trick to is to assure extended styles override
// their base component styles
// https://github.com/styled-components/styled-components/issues/382
const MobileStyledImage = styled(Image)`
  &&& {
    height: 100%;
    object-fit: cover !important;
  }
`

export default ImageHero
